<template>
  <button
    :class="{ 'simple-button--disabled': $attrs.disabled }"
    data-testid="simple-button-action"
    class="wrn-text-center wrn-p-05 simple-button__label wrn-link wrn-display-block-sm"
    v-on="$listeners"
  >
    <slot />
    {{ label }}
  </button>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
/**
 * @deprecated - use Nebraska button instead
 */
export default class SimpleButton extends Vue {
  @Prop({ type: String })
  public label!: string;

  private created() {
    console.warn(
      'Using deprecated SimpleButton, please use Nebraska ModalButton instead.'
    );
  }
}
</script>

<style lang="less" scoped>
button {
  background: transparent;
  border: 0;
  cursor: pointer;
}
.simple-button--disabled {
  color: @text-disabled !important;
  cursor: not-allowed;
}
.simple-button__label {
  text-transform: uppercase;
  font-size: 1.125rem;
  letter-spacing: 0.03125rem;
  font-weight: 700;
  margin-top: 0;
  margin-bottom: 0;
}
</style>
